"use client";

import { Skeleton } from "@/components/ui/skeleton";

export function LoadingSpinner() {
  return (
    <div className="space-y-3 p-4">
      <Skeleton className="h-9 w-full" />
      <Skeleton className="h-9 w-5/6" />
      <Skeleton className="h-9 w-4/5" />
      <Skeleton className="h-9 w-3/4" />
    </div>
  );
}
